// src/components/modal/address/AddressSelectionModal.jsx
import React from "react";
import { X, MapPin, Home } from "lucide-react";

const formatCEP = (cep) => {
  const clean = String(cep || "").replace(/\D/g, "");
  if (clean.length <= 5) return clean;
  return `${clean.slice(0, 5)}-${clean.slice(5, 8)}`;
};

export default function AddressSelectionModal({
  isOpen,
  addresses,
  onSelect,
  onClose,
}) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-[10001] p-4">
      <div className="bg-white rounded-2xl max-w-2xl w-full max-h-[90vh] overflow-hidden flex flex-col">
        {/* Header */}
        <div className="p-6 border-b flex items-center justify-between">
          <div>
            <h2 className="text-xl font-bold text-gray-900 flex items-center gap-2">
              <MapPin className="w-6 h-6 text-brand-primary" />
              Selecione seu Endereço
            </h2>
            <p className="text-sm text-gray-600 mt-1">
              Escolha o endereço para calcular o frete
            </p>
          </div>
          <button
            onClick={onClose}
            className="p-2 hover:bg-gray-100 rounded-full transition"
            aria-label="Fechar"
          >
            <X className="w-5 h-5 text-gray-500" />
          </button>
        </div>

        {/* Lista de Endereços */}
        <div className="flex-1 overflow-y-auto p-6">
          {addresses.length === 0 ? (
            <div className="text-center py-12">
              <Home className="w-16 h-16 text-gray-300 mx-auto mb-4" />
              <p className="text-gray-600 font-medium">
                Nenhum endereço cadastrado
              </p>
              <p className="text-gray-500 text-sm mt-2">
                Por favor, preencha o endereço manualmente
              </p>
            </div>
          ) : (
            <div className="space-y-3">
              {addresses.map((addr) => (
                <button
                  key={addr.id}
                  onClick={() => onSelect(addr)}
                  className="w-full text-left p-4 border-2 border-gray-200 rounded-xl hover:border-brand-primary hover:bg-red-50 transition-all group"
                >
                  <div className="flex items-start gap-3">
                    <div className="flex-shrink-0 mt-1">
                      <div className="w-10 h-10 rounded-full bg-brand-primary/10 flex items-center justify-center group-hover:bg-brand-primary/20 transition">
                        <Home className="w-5 h-5 text-brand-primary" />
                      </div>
                    </div>
                    <div className="flex-1 min-w-0">
                      <h3 className="font-semibold text-gray-900 mb-1">
                        {addr.logradouro}, {addr.number}
                      </h3>
                      {addr.complemento && (
                        <p className="text-sm text-gray-600 mb-1">
                          {addr.complemento}
                        </p>
                      )}
                      <p className="text-sm text-gray-600">
                        {addr.bairro} - {addr.localidade}/{addr.uf}
                      </p>
                      <p className="text-sm font-medium text-brand-primary mt-2">
                        CEP: {formatCEP(addr.cep)}
                      </p>
                    </div>
                  </div>
                </button>
              ))}
            </div>
          )}
        </div>

        {/* Footer */}
        <div className="p-6 border-t bg-gray-50">
          <button
            onClick={onClose}
            className="w-full px-4 py-2 rounded-xl border-2 border-gray-300 text-gray-700 font-semibold hover:bg-gray-100 transition"
          >
            Preencher manualmente
          </button>
        </div>
      </div>
    </div>
  );
}
